import { connect } from 'react-redux'
import _ from 'lodash'

const HasPermission = (props) => {
    const hasPermisison = Boolean(_.find(props.permissions, p => p.name === props.name))
    return hasPermisison ? props.children : null
}

const mapStateToProps = state => ({
    permissions: state.auth.permissions
})

export default connect(mapStateToProps)(HasPermission)



// WEBPACK FOOTER //
// ./src/containers/HasPermission/index.js